import { sha256 } from 'js-sha256';

import {
  type AnalyticsPatientResource,
  type AnalyticsPatient,
} from '@/types/metrics/analyticsPatient';

import { normalizePhoneNumber } from '../normalizePhoneNumber';

export const extractAnalyticsPatientData = <T extends AnalyticsPatientResource>(
  patient: T,
): AnalyticsPatient => {
  const normalizedPhone = patient.phone
    ? normalizePhoneNumber(patient.phone)
    : '';

  return {
    address1: patient.address1,
    address2: patient.address2,
    brand: patient.brand,
    city: patient.city,
    email: patient.email,
    firstname: patient.firstname,
    hashedEmail: sha256(patient.email),
    hashedPhone: sha256(normalizedPhone),
    id: patient.id,
    lastname: patient.lastname,
    phone: patient.phone,
    sessionId: patient.sessionId,
    zipcode: patient.zipcode,
  };
};
